module.exports = __webpack_public_path__ + "img/47.492648cc.jpg";